<template>
    <!-- Prélèvement sur une carte enregistrée du client (Stripe) -->
    <div class="ckp-remote">
        <div class="ckp-remote-name">
            <strong>Stripe</strong>
            <small>Carte enregistrée</small>
        </div>
        <div class="ckp-remote-controls">
            <select class="ckp-select" v-model="selectCard" aria-label="Carte de paiement">
                <option :value="null">{{ clientCards.length ? 'Choisir une carte' : 'Aucune carte' }}</option>
                <option v-for="card in clientCards" :key="card.id" :value="card">•••• •••• •••• {{ card.ending }}</option>
            </select>
            <span class="ckp-method-input"><input type="number" class="ckp-amount" min="1" v-model="amount" aria-label="Montant à prélever" /><span>€</span></span>
            <button v-if="!isPassing" type="button" class="ckp-icon" title="Ajouter une carte" aria-label="Ajouter une carte" @click="openAddCard"><i class="bi bi-plus-lg"></i></button>
        </div>
        <div class="ckp-remote-action">
            <button type="button" class="ck-button" :disabled="!selectCard || !amount || amount <= 0 || loadingPreleve" @click="prelever">
                {{ loadingPreleve ? 'Prélèvement…' : 'Prélever' }}
            </button>
        </div>
        <p v-if="errorPrelever" class="ckp-note is-error">{{ errorPrelever }}</p>
    </div>
</template>
<style>
.clientCards .v-input__slot {
    border-radius: 10px;
}
</style>
<script>
import axios from 'axios'
import { get } from 'vuex-pathify'

export default {
    props: ['userId', 'orderId'],
    mounted() {
        if (this.userId > 0) {
            this.getClientCards()
        }
        // Carte ajoutée depuis la modale du panneau (Overlay.vue)
        window.addEventListener('ck-card-added', this.newCardAdded)
    },
    beforeDestroy() {
        window.removeEventListener('ck-card-added', this.newCardAdded)
    },
    computed: {
        ...get('overlay@data', { c_customer: 'customer' }),
        isPassing() {
            return (this.c_customer?.first_name || '').toLowerCase() === 'client de passage'
        },
    },

    data: () => {
        return {
            menu: false,
            cartNum: null,
            expire: null,
            cvv: null,
            valid: false,
            loadingAddCart: false,
            clientCards: [],
            selectCard: null,
            loadingPreleve: false,
            errorPrelever: null,
            amount: 0,
            rules: {
                valid_num_cart: value => {
                    const pattern = /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/
                    return pattern.test(value) || 'Format incorect (XXXX-XXXX-XXXX-XXXX)'
                },
                valid_expire: value => {
                    const pattern = /^[0-9]{2}\/[0-9]{2}$/
                    return pattern.test(value) || 'Format incorect (MM/YY)'
                },
                valid_cvv: value => {
                    const pattern = /^[0-9]{3}$/
                    return pattern.test(value) || 'Format incorect (XXX)'
                },
                required: value => !!value || 'Element requis.',
            },
        }
    },
    watch: {
        cartNum(val) {
            let newFormat = this.insertAfterEveryN(`${val}`.replaceAll('-', ''), '-', 4, 3)
            if (newFormat.length > 19) newFormat = newFormat.substring(0, 19)

            if (val === newFormat) return

            this.cartNum = newFormat
        },
        expire(val) {
            let newFormat = this.insertAfterEveryN(`${val}`.replaceAll('/', ''), '/', 2, 1)
            if (newFormat.length > 5) newFormat = newFormat.substring(0, 5)

            if (val === newFormat) return

            this.expire = newFormat
        },
    },
    methods: {
        insertAfterEveryN(str, char, n, res) {
            const result = str.split('').reduce((accumulator, current, index) => {
                if (index % n === res) {
                    return accumulator + current + char
                }

                return accumulator + current
            }, '')

            return result
        },
        async getClientCards() {
            await axios.get(`/back-office/caisse/getPaymentMethod/${this.userId}`).then(res => {
                this.clientCards = res.data
            })
        },
        async prelever() {
            this.errorPrelever = null
            this.loadingPreleve = true
            axios
                .post(
                    `/back-office/caisse/payByStripe`,
                    {
                        montant: this.amount,
                        userId: this.userId,
                        orderId: this.orderId,
                        cartId: this.selectCard.id,
                    },
                    { withCredentials: true }
                )
                .then(() => {
                    window.location.reload()
                })
                .catch(error => {
                    this.errorPrelever = error?.response?.data?.message || 'Une erreur est survenue'
                })
                .finally(() => {
                    this.loadingPreleve = false
                })
        },
        async addClientCard() {
            this.loadingAddCart = true
            await axios
                .post(
                    `/back-office/customer/${this.userId}/payment/updatePaymentMethode`,
                    {
                        card_number: `${this.cartNum}`.replaceAll('-', ''),
                        card_date: `${this.expire}`,
                        card_cvc: `${this.cvv}`,
                    },
                    { withCredentials: true }
                )
                .then(res => {
                    this.menu = false
                    this.getClientCards()
                })
                .finally(() => {
                    this.loadingAddCart = false
                })
        },
        newCardAdded() {
            if (this.userId > 0) this.getClientCards()
        },
        openAddCard() {
            window.dispatchEvent(new CustomEvent('ck-open-add-card'))
        },
    },
}
</script>
